//var Messenger = require('./messenger.js');
import Messenger from './messenger.js'
/**
 * 继承Messenger类，增加事件，请求等方法，简化框架之间通信
 *
 *  @class Messenger_ext
 *  @classdesc 继承Messenger类，增加事件，请求等方法，简化框架之间通信
 *  @extends Messenger
 */
/**
 * 回调函数
 * @callback Messenger_ext~callback
 * @param {Object} data 数据
 * @this Messenger
 */

/**
 * 初始化
 *
 * @access private
 */
Messenger.prototype._init = function () {
    var me = this;
    if (me._extInit) {
        return;
    }
    me._extInit = true;
    me.listen(function (data) {
        data = data || {};
        if (typeof data === 'string') {
            data = JSON.parse(data);
        }
        if (data.eventName) {
            me._trigger(data.eventName, data);
        }
    });
};

/**
 * 事件监听
 * @access public
 * @method Messenger_ext.prototype.on
 * @param {string} eventName 事件名
 * @param {Messenger_ext~callback} callback 回调函数
 * @param {string} handlerId 为匿名函数准备的卸载id
 */

Messenger.prototype.on = function (eventName, callBack, handlerId) {
    this._init();
    this.listObj = this.listObj || {};
    this.listObj[eventName] = this.listObj[eventName] || [];
    var item = handlerId ? {id: handlerId, handler: callBack} : callBack;
    this.listObj[eventName].push(item);
};

/**
 * 触发事件,调用监听事件的回调函数
 * @access private
 */

Messenger.prototype._trigger = function (eventName, data) {
    data = data || {};
    if (!this.listObj) {
        return;
    }
    var eventStack = this.listObj[eventName];
    if (!eventStack || !eventStack.length) {
        return;
    }
    var i = 0;
    var len = eventStack.length;
    for (i; i < len; i++) {
        var handler = eventStack[i];
        handler.call(this, data);
    }
};

/**
 * 触发事件
 *
 * @access public
 * @method Messenger_ext.prototype.trigger
 * @param {string} eventName 事件名
 * @param {Object} data 数据
 */
Messenger.prototype.trigger = function (eventName, data) {
    data = data || {};
    if (typeof data === 'string') {
        data = JSON.parse(data);
    }
    data.eventName = eventName;
    this.send(JSON.stringify(data));
};

/**
 * 移除事件监听
 *
 * @access public
 * @method Messenger_ext.prototype.un
 * @param {string} eventName 事件名
 * @param {Function|string} handlerId 回调函数句柄或回调函数id
 */
Messenger.prototype.un = function (eventName, handlerId) {
    if (!this.listObj) {
        return;
    }
    if (arguments.length === 0) {
        this.listObj = null;
        return;
    }
    if (arguments.length === 1 && eventName) {
        this.listObj[eventName] = null;
        return;
    }
    if (!this.listObj
        || !this.listObj[eventName] || !this.listObj[eventName].length) {
        return;
    }
    var eventStack = this.listObj[eventName];
    var i = 0;
    while (eventStack[i]) {
        var handler = eventStack[i];
        if (typeof handlerId === 'string') {
            if (typeof handler === 'object' && handler.id === handlerId) {
                this.listObj[eventName].splice(i, 1);
                continue;
            }
        }
        else {
            if (handler === handlerId) {
                this.listObj[eventName].splice(i, 1);
                continue;
            }
        }
        i++;
    }
};

/**
 * one 仅监听一次
 *
 * @access public
 * @method Messenger_ext.prototype.one
 * @param {string} eventName 事件名
 * @param {Messenger_ext~callback} callBack 回调函数
 */
Messenger.prototype.one = function (eventName, callBack) {
    var me = this;
    var func = function (data) {
        me.un(eventName, callBack);
        callBack.call(me, data);
    };
    me.on(eventName, func);
};

/**
 * response 响应其他窗体通过postMessage触发的事件
 *
 * @access public
 * @method Messenger_ext.prototype.response
 * @param {string} eventName 事件名
 * @param {Messenger_ext~callback} callBack 回调函数
 */
Messenger.prototype.response = function (eventName, callBack) {
    var me = this;
    var listenName = '__REQUEST__' + eventName;
    var func = function (data) {
        var callBackName = data.callBackName;
        var done = function (resp) {
            if (typeof resp === 'object') {
                resp = JSON.stringify(resp);
            }
            me.trigger(callBackName, resp);
        };
        callBack.call(me, data, done);
    };
    me.on(listenName, func);
};

/**
 * request 通过事件请求其他窗体
 *
 * @access public
 * @method Messenger_ext.prototype.request
 * @param {string} eventName 事件名
 * @param {Object} options 配置信息
 * @param {Messenger_ext~callBack} options.callBack 回调函数
 * @param {Object} options.data 数据
 */
Messenger.prototype.request = function (eventName, options) {
    options = options || {};
    var callBack = options.callBack;
    var data = options.data || {};
    var callName = '__REQUEST__' + eventName;
    var listenName = '__RESPONSE__' + eventName + '__' + (new Date()).getTime();
    data.callBackName = listenName;
    if (callBack) {
        this.one(listenName, callBack);
    }
    this.trigger(callName, data);
};

export default Messenger;



// WEBPACK FOOTER //
// ./src/js/messenger_ext.js